

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";

export default function ProtectedRoutClint({ allowed = [] }) {
  const { isAuth, user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null; // أو Spinner

  if (!isAuth) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const role = user?.type || user?.role;

  if (allowed.length && !allowed.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />; // ✅ مهم جدًا
}
